import React, { useEffect, useState } from "react";
import { DropzoneUploadDocs } from "./Dropzone";
import { Btn } from "../../styles/Button.styled";
import { useMediaQuery } from "react-responsive";

import { Container } from "../../styles/Sidebar/UploadModal.styled";
import { CircularProgress } from "@mui/material";

import { docsFilter } from "../../actions/filter";
import { UPLOAD_RESET, UPLOAD_START_BATCH, uploadDocs } from "../../actions/upload";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../hooks";
import Popup from "./Popup";
// import { Select } from "../inputs/Select";
import { getTypes } from "../../actions/types";
import { AttributeItem } from "../attributes/interfacesAttr";
import { AutocompleteInputCustom } from "../inputs/AutocompleteInputCustom";

export interface OptionsProps {
  id: string;
  title: string;
  attributes: {
    attribute: AttributeItem;
    mandatory: boolean;
  }[];
}

interface Props {
  handleClose: () => void;
  className?: string;
  initialFiles?: File[];
}

export function UploadModal(props: Props) {
  const [agreement, setAgreement] = useState<OptionsProps>();
  const [checkExtension, setCheckExtension] = useState(true);

  const upload = useAppSelector((state) => state.upload);
  const filter = useAppSelector((state) => state.filter);
  const types = useAppSelector((state) => state.types);

  const dispatch = useAppDispatch();
  const [selectedFiles, setSelectedFiles] = useState<File[]>(props.initialFiles ?? []);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const navigate = useNavigate();

  const handleFileDrop = (newFiles: File[]) => {
    setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };
  const readFileAsBase64 = (
    file: File,
  ): Promise<{ file: string; name: string }> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = btoa(reader.result as string);
        resolve({
          file: base64,
          name: file.name,
        });
      };
      reader.onerror = reject;
      reader.readAsBinaryString(file);
    });
  };
  const options =
    types.state === "success" && types.list.length > 0 ? types.list : agreement;
  const defaultAgreement =
    types.state === "success" && types.list.length > 0 ? types.list.find(el => el.title ==="").id : "";


  const handleUpload = async () => {
  if (!selectedFiles.length ) return;
const total = selectedFiles.length ;
  dispatch({
    type: UPLOAD_START_BATCH,
    payload: { total: total }
  });

  if (selectedFiles.length > 1) {
    navigate("/documents/all");
  }
  closePopup(false);

  for (const file of selectedFiles) {
     const fileData = await readFileAsBase64(file);
        const payload = {
          file: fileData.file,
          name: fileData.name,
          type: agreement?.id ?? defaultAgreement,
        }; 
    await dispatch(uploadDocs(payload));

  }
   dispatch(docsFilter(filter.scope));
   dispatch({ type: UPLOAD_RESET });
};

const closePopup = (resetUpload = true) => {
  props.handleClose();
  setSelectedFiles([]);
  if (resetUpload) {
    dispatch({ type: UPLOAD_RESET });
  }
};
  const deleteAllSelectedFiles = () => {
    setSelectedFiles([]);
  };

  const handleRemoveFile = (indexToRemove: number) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove),
    );
    setCheckExtension(true);
  };
  const disabledBtnDelAll = selectedFiles.length < 1;
  const disabledDropZone = upload.state === "loading";
  const disabledDownLoadBtn =
    upload.state === "loading" || disabledBtnDelAll ;


useEffect(() => {
  if (upload.state === "success" && upload.total === 1) {
    dispatch(docsFilter(filter.scope));
    navigate(`/documents/${upload.id}/view`);
  }

  if (upload.state === "success" && upload.current === upload.total) {
    dispatch(docsFilter(filter.scope));
  }
}, [upload.state, upload.current]);


  useEffect(() => {
    if (agreement && agreement?.attributes.length > 0) {
      console.log();
    }
  }, [agreement]);

  useEffect(() => {
    if (types.state === "idle") {
      dispatch(getTypes());
    }
    if (types.state === "error") {
      setAgreement({
        id: "0",
        title: "Доступних типів не знайдено",
        attributes: [],
      });
    }
  }, [types]);

  return (
    <Popup
      clickCloseButton={closePopup}
      className={props.className}
      style={{ height: "auto" }}
    >
      <h1>Завантаження документа в eDoc</h1>
      <p>Виберіть файл або групу файлів формату PDF</p>
      <Container>
        <div style={{ marginBottom: "32px" }}>
          <AutocompleteInputCustom
            label={"Тип документу"}
            value={agreement?.id }
            options={options}
            onChange={(e) => setAgreement(e)}
            placeholder="Оберіть або введіть"
            disabled={upload.state === "loading" || upload.state === "success"}
            style={{ flexShrink: 0 }}
          />
        </div>
        {/* {Array.isArray(agreement?.attributes) &&
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                    padding: "10px",
                    marginTop: "20px",
                }}
                >
                {Array.isArray(agreement?.attributes) &&
                    agreement?.attributes.map((el) => (
                    <AttributeFactory
                        key={el.attribute.id}
                        item={el.attribute}
                        handleUpdate={handleUpdate}
                    />
                ))}
            </div>
        } */}
        <DropzoneUploadDocs
          checkExtension={checkExtension}
          setCheckExtension={setCheckExtension}
          onFileDrop={handleFileDrop}
          selectedFiles={selectedFiles ?? []}
          isMobile={isMobile}
          onRemoveFile={handleRemoveFile}
          failure={upload.state === "failure"}
          disabled={disabledDropZone}
        />
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            // $height={isMobile ? '40px' : '47px'}
            $marginTop="0"
            onClick={deleteAllSelectedFiles}
            $background="var(--sidebar-hover)"
            $heightMobile="47px"
            disabled={disabledBtnDelAll}
          >
            Видалити всі
          </Btn>

          {selectedFiles && (
            <Btn
              type="submit"
              $width="100%"
              $marginTop="0"
              $background="var(--blue)"
              $disabledColor="var(--disabled-c)"
              $disabledC="var(--white)"
              $heightMobile="47px"
              onClick={handleUpload}
              disabled={disabledDownLoadBtn}
            >
              {upload.state !== "loading" ? (
                "Завантажити"
              ) : (
                <CircularProgress
                  size={24}
                  sx={{
                    color: "var(--white)",
                  }}
                />
              )}
            </Btn>
          )}
        </div>
      </Container>
    </Popup>
  );
}
